import { safeDefine } from "../../registration/safe-define.js";
import { PlaybackRateButtonElement } from "../../ui/playback-rate-button/element.js";
//#region src/define/ui/playback-rate-button.ts
safeDefine(PlaybackRateButtonElement);
//#endregion
